export default "__VITE_ASSET__BQUwbmsz__"